<template>
    <div class="chat">
        <div class="row d-none d-lg-inline chat-header">
            <h2 v-if="!listArchivedChats" class="col">Guest Chats</h2>
            <div v-else class="col" @click="toggleArchivedChats">
                <i class="fas fa-arrow-left"></i>
                <h4>Archived</h4>
            </div>
        </div>

        <div class="row d-inline d-md-none chat-header">
            <div v-if="listArchivedChats && !selectedChat" class="col" @click="toggleArchivedChats">
                <i class="fas fa-arrow-left"></i>
                <h4>Archived</h4>
            </div>
        </div>

        <div class="row chat-content">
            <div class="col-12 col-md-4 chat-all-conv" v-bind:class="{'d-none d-md-block' : selectedChat}">

                <Spinner v-if="loading"/>

                <template  v-else-if="chats">
                    <div v-if="hasArchivedChats && !listArchivedChats" @click="toggleArchivedChats" class="chat-all-conv__archived-button">
                        <div>
                            <div class="chat-icon">
                                <i class="fas fa-archive"></i>
                            </div>
                            <div class="chat-summ">
                                Archived Chats
                            </div>
                        </div>
                    </div>

                    <ul>
                        <li v-for="(chat, index) in chats.content" v-bind:key="index" v-on:click="selectChat(chat.reference)" v-bind:class="{'chat-all-conv--selected' : selectedChat && chat.reference === selectedChat.reference}">
                            <div>
                                <div class="chat-icon">
                                    <i class="fas fa-user"></i>
                                </div>
                                <div class="chat-summ">
                                    <div>
                                        <div class="chat-summ--name">{{chat.guestProfileName}}</div>
                                        <div class="chat-summ--date"  v-bind:class="{'chat-summ--date--selected' : selectedChat && chat.reference === selectedChat.reference}">{{smartTimeOrDate(chat.lastMessage.created)}}</div>
                                    </div>
                                    <div>
                                        <div class="chat-summ--text">{{chat.lastMessage.content}}</div>
                                        <div v-if="chat.unreadCount > 0" class="chat-summ--unread-cnt text-right"><span>{{chat.unreadCount}}</span></div>
                                        <template v-if="listArchivedChats">
                                            <div class="chat-summ--archive" 
                                                v-on:click.stop="unarchiveChat(chat.reference)"
                                                v-bind:class="{'d-inline-block' : selectedChat && chat.reference === selectedChat.reference}"><i class="fas fa-box-open"></i></div>
                                        </template>
                                        <template v-else>
                                            <div class="chat-summ--archive" 
                                                v-on:click.stop="archiveChat(chat.reference)"
                                                v-bind:class="{'d-inline-block' : selectedChat && chat.reference === selectedChat.reference}"><i class="fas fa-archive"></i></div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li v-if="chats.content.length === 0">
                            <div class="d-block text-center mt-3">
                                You don't yet have any chats with guests.<br><br>
                                If you haven't set up WhatsApp,<br> please <router-link to="/list-establishments">go to Configure Establishments</router-link><br> and click on WhatsApp.
                            </div>
                        </li>
                        <li v-if="canLoadMoreChats" class="text-center">
                        <button v-on:click="moreChats()" class="btn btn-secondary w-auto">More</button>
                        </li>
                    </ul>
                </template>
            </div>

            <div ref="chatDetail" class="d-none d-md-flex col-12 col-md-8 chat-conv-detail" v-bind:class="{'d-flex' : selectedChat}">
                <template v-if="selectedChat">
                    <div class="d-flex d-md-none chat-conv-detail__header">
                        <span v-on:click="deselectChat()"><i class="fas fa-chevron-left"></i></span>
                        <h4>{{selectedChat.guestProfileName}}</h4>
                        <span v-if="!listArchivedChats" v-on:click.stop="archiveChatAndReturnToListOfChats(selectedChat.reference)"><i class="fas fa-archive"></i></span>
                        <span v-if="listArchivedChats" v-on:click.stop="unarchiveChatAndReturnToListOfChats(selectedChat.reference)"><i class="fas fa-box-open"></i></span>
                        <span v-on:click.stop="showSelectedChatBookings"><i class="fas fa-bed"></i></span>
                    </div>

                    <div class="col chat-conv-detail__contact" v-bind:class="{'d-none d-md-block' : selectedChat}">
                        <div class="row">
                            <div class="col-4 col chat-conv-detail__contact__details">
<!--                                <div>Image</div>-->
                                <div><h5>{{selectedChat.guestProfileName}}</h5></div>
                                <div>{{selectedChat.guestMobile}}</div>
                            </div>
                            <div class="col-8  chat-conv-detail__contact__bookings">
                                <table>
                                    <thead>
                                        <th><i class="fas fa-door-open"></i></th>
                                        <th><i class="fas fa-door-closed"></i></th>
                                        <th><i class="fas fa-bed"></i></th>
                                        <th><i class="fas fa-male adult"></i><i class="fas fa-male adult"></i></th>
                                    </thead>
                                    <tr v-for="(booking) in selectedChat.bookings" v-bind:key="booking.reference" v-on:click="openBooking(booking)">
                                        <td>{{friendlyDate(booking.arrival)}}</td>
                                        <td>{{friendlyDate(booking.departure)}}</td>
                                        <td>
                                            <span v-for="(room, index) in booking.rooms" v-bind:key="room.reference">
                                                <template v-if="index > 0">,</template>
                                                {{room.name}}
                                            </span>
                                        </td>
                                        <td>{{getTotalGuestsForBooking(booking)}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="d-none d-md-block chat-conv-detail__divider"><div></div></div>

                    <div ref="messagesWindow" class="chat-conv-detail__messages-scrollable">

                        <div v-if="!selectedChat.messages.hasNext" class="text-center text-muted">
                            All messages loaded
                        </div>

                        <Spinner class="" v-show="loadingMessages"/>

                        <div class="chat-conv-detail__messages">
                            <ChatMessage v-for="(message, index) in selectedChat.messages.content" v-bind:key="index" v-bind:message="message" :unreadCountForDisplayInChat="selectedChat.unreadCountForDisplayInChat"></ChatMessage>
                        </div>

                    </div>

                    <SendMessageBar v-bind:chat="selectedChat" v-bind:chatWindowHeight="this.chatWindowHeight   "/>

                </template>

                <template v-else>
                    <div class="chat-conv-detail--no-chat-selected">
                        <i class="fas fa-comments"></i>
<!--                        <i class="fab fa-whatsapp"></i>-->
                        <h3>WhatsApp chats by BetterGuest</h3>
                    </div>
                </template>

            </div>
        </div>

        <bookings-list-dialog v-bind:bookings="selectedChat.bookings" v-if="showBookingsList"></bookings-list-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';

    import { store } from '../store.js'

    import Spinner from '../components/Spinner.vue'
    import BookingsListDialog from '../components/whatsapp/ListBookingsDialog.vue'
    import ChatMessage from '../components/whatsapp/ChatMessage.vue'
    import SendMessageBar from '../components/whatsapp/SendMessageBar.vue'

    import {chatMessageMixin} from "../mixins/ChatMessageMixin.js"
    import {datesMixin} from "../mixins/DatesMixin"
    import {stringsMixin} from "../mixins/StringsMixin"
    import {bookingsMixin} from "../mixins/BookingsMixin"

    export default {
        name: 'GuestChats',
        components: { Spinner, BookingsListDialog, ChatMessage, SendMessageBar },
        mixins: [chatMessageMixin, datesMixin, stringsMixin, bookingsMixin],
        data: function () {
            return {
                listArchivedChats: false,
                hasArchivedChats: false,
                chats: null,
                selectedChat: null,
                unreadStartMessage: null,
                loading: true,
                loadingMessages: false,
                chatPageNumber: 0,
                chatPageSize: 10,
                chatMessagesPageNumber: 0,
                chatMessagesPageSize: 10,
                showBookingsList: false,
                showTripDetails: false,
                trip: null,
                chatWindowHeight: 800
            }
        },
        computed: {
          canLoadMoreChats: function () {
              if (this.chats && this.chats.hasNext) {
                return true;
              }
              return false;
          }
        },
        methods: {
            establishmentSelected: function() {
                this.fetchFirstPageOfChats();
            },
            checkIfHasArchivedChats: async function() {
                console.log("Checking if establishment has archived chats");
                try {
                    const response = await this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/has-archived', {
                        withCredentials: true
                    });
                    this.hasArchivedChats = response.data;
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false;
                }
            },
            toggleArchivedChats: function() {
                this.listArchivedChats = !this.listArchivedChats;
                this.fetchFirstPageOfChats();
            },
            fetchPageOfChats: function (callback) {
                this.loading = true;
                let params = {
                    pageNumber: this.chatPageNumber,
                    pageSize: this.chatPageSize
                };
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats' + (this.listArchivedChats ? '/archived' : ''), {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchFirstPageOfChats: function() {
                this.resetData();
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats = pageOfChats;
                })
            },
            resetData: function() {
                this.selectedChat = null;
                this.unreadStartMessage = null;
                this.chatPageNumber = 0;
                this.chatMessagesPageNumber = 0;
                this.chats = null;
            },
            moreChats: function () {
                this.chatPageNumber++;
                console.log("fetching page of chats: " + this.chatPageNumber)
                this.fetchPageOfChats((pageOfChats) => {
                    console.log(pageOfChats)
                    this.chats.content.push(...pageOfChats.content)
                    this.chats.hasNext = pageOfChats.hasNext;
                    this.chats.hasPrevious = pageOfChats.hasPrevious;
                })
            },
            fetchChat: async function (reference, callback) {
                this.loading = true;
                return this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + reference, {
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loading = false
                })
            },
            fetchPageOfMessages: function (callback) {
                this.loadingMessages = true;
                let params = {
                    pageNumber: this.chatMessagesPageNumber,
                    pageSize: this.chatMessagesPageSize
                };
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/messages', {
                    params,
                    withCredentials: true
                }).then(response => {
                    callback(response.data)
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    this.loadingMessages = false
                })
            },
            fetchPageOfMessagesBefore: async function (messageReference) {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/messages/before/' + messageReference;
                return await this.fetchPageOfMessagesBeforeOrAfter(url);
            },
            fetchPageOfMessagesAfter: async function (messageReference) {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/messages/after/' + messageReference;
                return await this.fetchPageOfMessagesBeforeOrAfter(url);
            },
            fetchPageOfMessagesBeforeOrAfter: async function (url) {
                this.loadingMessages = true;
                let params = {
                    pageSize: this.chatMessagesPageSize
                };
                try {
                    const response = await this.$http.get(url, {
                        params,
                        withCredentials: true
                    });
                    return response.data;
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loadingMessages = false;
                }
            },
            selectChat: async function(reference) {
                console.log("Selected chat " + reference); 
                if (this.selectedChat) {
                    this.deselectChat();
                }
                await this.fetchSelectedChat(reference);
                this.findFirstUnreadMessageInSelectedChat();
                this.updateChatWindowHeight();
                this.addScrollListenerAndScrollToFirstUnreadOrBottom();
                await this.chatRead();
            },
            deselectChat: function() {
                this.selectedChat = null;
                this.unreadStartMessage = null;
                if (this.$refs.messagesWindow) {
                    this.$refs.messagesWindow.removeEventListener("scroll", this.scrollHandler);
                }
            },
            fetchSelectedChat: async function(reference) {
                return this.fetchChat(reference, (chat) => {
                    this.selectedChat = chat;
                    this.fetchGuestBookings(this.selectedChat.guestMobile);
                })
            },
            findFirstUnreadMessageInSelectedChat: function() {
                if (this.selectedChat && this.selectedChat.messages && this.selectedChat.unreadCount > 0) {
                    // find the index of the last read message - must be a guest message, and unread
                    let lastReadIndex = this.selectedChat.messages.content.findLastIndex(message => {
                        if (this.isMessageHostMessage(message) || this.isMessageSystemMessage(message)) {
                            return true;
                        }
                        if (this.isMessageRead(message)) {
                            return true;
                        }
                        return false;
                    });
                    // if there are no read messages, set the last read index to -1, so we will select the first message
                    if (!lastReadIndex) {
                        lastReadIndex = -1;
                    }
                    // the next message is the first unread message
                    if (lastReadIndex < this.selectedChat.messages.content.length - 1) {
                        let firstUnread = this.selectedChat.messages.content[lastReadIndex + 1];
                        Vue.set(firstUnread, 'showUnread', true);
                        this.unreadStartMessage = firstUnread;
                    }
                    Vue.set(this.selectedChat, 'unreadCountForDisplayInChat', this.selectedChat.unreadCount);
                }
            },
            updateChatWindowHeight: function() {
                console.log("Updating chat window height");
                if (this.$refs.chatDetail) {
                    this.chatWindowHeight = this.$refs.chatDetail.clientHeight;
                    console.log("Updated chat window height");
                }
            },
            addScrollListenerAndScrollToFirstUnreadOrBottom: function() {
                this.$nextTick(() => {
                    this.$refs.messagesWindow.addEventListener("scroll", this.scrollHandler);
                    if (this.unreadStartMessage) {
                        console.log("Scrolling to first unread message");
                        this.scrollToUnreadBar();
                    } else {
                        console.log("Scrolling to bottom of chat");
                        this.scrollToEndOfChat();
                    }
                });
            },
            moreMessages: async function () {
                if (this.selectedChat && this.selectedChat.messages.hasNext) {
                    console.log("fetching page of messages before: " + this.selectedChat.messages.content[0].reference);
                    try {
                        const oldHeight = this.$refs.messagesWindow.scrollHeight;

                        const pageOfMessages = await this.fetchPageOfMessagesBefore(this.selectedChat.messages.content[0].reference);
                        console.log(pageOfMessages)
                        this.selectedChat.messages.content.unshift(...pageOfMessages.content);
                        this.selectedChat.messages.hasNext = pageOfMessages.hasNext;

                        this.$nextTick(() => {
                            const newScrollHeight = this.$refs.messagesWindow.scrollHeight;
                            // Adjust scrollTop by the difference
                            this.$refs.messagesWindow.scrollTop += (newScrollHeight - oldHeight);
                        });
                    } catch (error) {
                        console.log(error);
                    }
                }
            },
            scrollToUnreadBar: function() {
                console.log("Scrolling to unread bar");
                if (this.$refs.unreadBar) {
                    console.log(this.$refs.unreadBar);
                    console.log(this.$refs.messagesWindow);
                    this.$refs.messagesWindow.scrollTop = this.$refs.unreadBar[0].offsetTop - this.$refs.messagesWindow.offsetTop;
                }
            },
            scrollToEndOfChat: function() {
                this.$refs.messagesWindow.scrollTo(0, this.$refs.messagesWindow.scrollHeight);
            },
            scrollHandler: function() {
                console.log("Scrolling");
                let topOfWindow = this.$refs.messagesWindow.scrollTop === 0;
                if (topOfWindow) {
                    console.log("Scrolled to TOP");
                    this.moreMessages();
                }
            },
            chatRead: async function() {
                console.log("Checking if need to mark chat as read");
                if (this.selectedChat && this.selectedChat.unreadCount > 0) {
                    console.log("Need to mark chat as read");
                    await this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + this.selectedChat.reference + '/read');
                    for (let chat of this.chats.content) {
                        if (chat.reference === this.selectedChat.reference) {
                            chat.unreadCount = 0;
                        }
                    }
                }
            },
            archiveChat: async function(reference) {
                console.log("Archiving chat " + reference);
                await this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + reference + '/archive');
                this.chats.content = this.chats.content.filter(chat => chat.reference !== reference);
                if (this.selectedChat && this.selectedChat.reference === reference) {
                    this.deselectChat();
                }
                this.hasArchivedChats = true;
            },
            archiveChatAndReturnToListOfChats: async function(reference) {
                await this.archiveChat(reference);
                this.deselectChat();
            },
            unarchiveChat: async function(reference) {
                console.log("Unarchiving chat " + reference);
                await this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/chats/' + reference + '/unarchive');
                this.chats.content = this.chats.content.filter(chat => chat.reference !== reference);
                if (this.selectedChat && this.selectedChat.reference === reference) {
                    this.deselectChat();
                }
                await this.checkIfHasArchivedChats();
                if (!this.hasArchivedChats) {
                    this.toggleArchivedChats();
                }
            },
            unarchiveChatAndReturnToListOfChats: async function(reference) {
                await this.unarchiveChat(reference);
                this.deselectChat();
            },  
            showSelectedChatBookings: function() {
                if (this.selectedChat && this.selectedChat.bookings) {
                    this.showBookingsList = true;
                }
            },
            hideSelectedChatBookings: function() {
                this.showBookingsList = false;
            },
            showTrip: function (booking) {
                this.hideSelectedChatBookings();
                this.openBooking(booking);
            },
            chatUpdated: async function(updatedChat) {
                for (let chat of this.chats.content) {
                    if (chat.reference === updatedChat.reference) {
                        Object.assign(chat, updatedChat);
                        if (this.selectedChat && this.selectedChat.reference === updatedChat.reference) {
                            this.selectedChat.unreadCount = updatedChat.unreadCount;
                            this.updateSelectedChat(updatedChat);
                        }
                        break;
                    }
                }
            },
            messageSent: async function(message) {
                if (this.selectedChat && this.selectedChat.reference === message.chatReference) {
                    console.log("Message sent in selected chat, adding to messages");
                    this.selectedChat.messages.content.push(message);
                    this.$nextTick(() => {
                        this.scrollToEndOfChat();
                    });
                }
            },
            messageUpdated: async function(updatedMessage) {
                if (this.selectedChat && this.selectedChat.reference === updatedMessage.chatReference) {
                    for (let message of this.selectedChat.messages.content) {
                        if (message.reference === updatedMessage.reference) {
                            Object.assign(message, updatedMessage);
                            break;
                        }
                    }
                }
            },
            updateSelectedChat: async function(updatedChat) {
                console.log("Selected chat updated");
                Vue.set(this.selectedChat, 'conversationWindowOpen', updatedChat.conversationWindowOpen);
                let maxFetches = 5;
                let fetchCount = 0;
                let hasNext = true;
                do {
                    const pageOfMessages = await this.fetchPageOfMessagesAfter(this.selectedChat.messages.content[this.selectedChat.messages.content.length - 1].reference);
                    console.log(pageOfMessages)
                    this.selectedChat.messages.content.push(...pageOfMessages.content);
                    hasNext = pageOfMessages.hasNext;
                    fetchCount++;
                } while (hasNext && fetchCount < maxFetches);
                
                if (this.unreadStartMessage) {
                    console.log("Updating first unread message");
                    const firstUnreadIndex = this.selectedChat.messages.content.findLastIndex(message => message.reference === this.unreadStartMessage.reference);
                    if (firstUnreadIndex > -1) {
                        this.selectedChat.messages.content[firstUnreadIndex].showUnread = true;
                        this.selectedChat.unreadCountForDisplayInChat = this.selectedChat.messages.content.length - firstUnreadIndex;
                    }
                } else {
                    this.findFirstUnreadMessageInSelectedChat();
                }
                this.addScrollListenerAndScrollToFirstUnreadOrBottom();
            },
            fetchGuestBookings: async function(mobile) {
                let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/search-mobile';
                try {
                    let response = await this.$http.get(url, {
                        params: {
                            mobile: mobile
                        },
                        withCredentials: true
                    });
                    Vue.set(this.selectedChat, 'bookings', response.data);
                } catch (error) {
                    console.log(error);
                }
            },
            openBooking: function(booking) {
                this.$root.$emit('open-trip-details', booking);
            }
        },
        mounted() {
            console.log("Loading chats");
            this.fetchFirstPageOfChats();
            this.checkIfHasArchivedChats();

            this.$nextTick(() => {
                this.updateChatWindowHeight();
            });

            window.addEventListener("resize", this.updateChatWindowHeight);

            this.$root.$on('chat-message-sent', this.messageSent);
            this.$root.$on('chat-updated', this.chatUpdated);
            this.$root.$on('message-updated', this.messageUpdated);
            this.$root.$on('close-bookings-list-dialog', this.hideSelectedChatBookings);
            this.$root.$on('show-trip', this.showTrip);
            this.$root.$on('selected-establishment', this.establishmentSelected);
        },
        beforeDestroy () {
            if (this.$refs.messagesWindow) {
              this.$refs.messagesWindow.removeEventListener("scroll", this.scrollHandler);
            }
            this.chatRead();

            window.removeEventListener("resize", this.updateChatWindowHeight);

            this.$root.$off('chat-message-sent', this.messageSent);
            this.$root.$off('chat-updated', this.chatUpdated);
            this.$root.$off('message-updated', this.messageUpdated);
            this.$root.$off('close-bookings-list-dialog', this.hideSelectedChatBookings);
            this.$root.$off('show-trip', this.showTrip);
            this.$root.$off('selected-establishment', this.establishmentSelected);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/_chat.scss";
    @import "../styles/layout/_forms.scss";
</style>